import { CommonSearchParamKey } from "@karrotmarket-com/core";

export type BuySellAllPageFilters = {
  regionId: string;
  categoryId?: string;
  sortBy?: string;
  price?: string;
  search?: string;
  onlyOnSale?: boolean;
};

export enum BuySellAllPageFilterKey {
  RegionId = "regionId",
  CategoryId = "categoryId",
  Price = "price",
  // biome-ignore lint/style/useLiteralEnumMembers: <explanation>
  Search = CommonSearchParamKey.Search,
  OnlyOnSale = "onlyOnSale",
}
